import { Component, ViewChild, OnInit,Input, Output,EventEmitter } from '@angular/core';
import { Globals } from '../../globals';
import { Helper } from '../../helper';
import {UploadService} from '../../lib/upload.service';
import { ModalComponent } from '../modal/modal.component';
import { ToastMode } from '../../include/structures';

@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.sass']
})
export class UploadFileComponent implements OnInit {

  @ViewChild('modal', { static: false })
  modal!: ModalComponent ;

  @Input()
  subdirectory!:string;

  @Input()
  description!:string;

  @Input()
  extensions:string="*";

  fileToUpload: File = null;
  
  filename!:string;
  default_filename:string="";

  @Input()
  params:any;

  @Input()
  record:any; //necessario nel caso di parserizzazione delle keyword dei parametri

  @Output()
  onUploaded:EventEmitter<string>=new EventEmitter<string>()
  

  progress=10;

  get readonly(){
    
    return Globals.readonly;
  }

  constructor(
    private uploadService:UploadService
  ) { }

  ngOnInit(): void {

    this.parseParams();

  }


  ngOnChanges(){
   
      
   
    
  }

  parseParams(){

    


    if(this.params){
      if(!Array.isArray(this.params)){
        try{
          this.params=JSON.parse(this.params);
        }catch{
          this.params=[];
        }
      }

      if(this.params.length>0){
        for(let p of this.params){
          if(p.name=="subdirectory"){
            this.subdirectory=this.parseKeyword(p.value,this.record);
          }

          if(p.name=="default_filename"){
            
            this.default_filename=this.parseKeyword(p.value,this.record);
          }
        }
      }

      
      

    }
  }

  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
    this.OnSubmit();
 }


  OnSubmit() {
    if(this.default_filename)
      this.default_filename=this.default_filename.replace("[filename]",this.fileToUpload.name);

    this.uploadService.uploadFile(this.fileToUpload,this.subdirectory,(result)=>{
      console.log(result);
      if(result['error']){
        Globals.message.showToaster("Errore nel caricamento del file",ToastMode.DANGER);
      }else{
      
        console.log(result);
        if(this['modalWindow'])
          this['modalWindow'].close("success");
        this.filename=result;
        this.onUploaded.emit(result);
  }
     
    },false,this.default_filename,(progress)=>{
      this.progress=progress;
    });
  }


  parseKeyword(value,record){
    
    if(record){
      
      return Helper.replaceKeyword(value,record);
    }
      
    else
      return value;
  }


  close(){
    this['modalWindow'].close("cancel");
  }
}
